import script from "./TermsForm.vue?vue&type=script&setup=true&lang=js"
export * from "./TermsForm.vue?vue&type=script&setup=true&lang=js"

import "./TermsForm.vue?vue&type=style&index=0&id=cf41f190&lang=css"

const __exports__ = script;

export default __exports__